import { Expose, Transform } from 'class-transformer';
import { Model } from './model';
import { UserGender } from '../../common';
import { checkIfNoValue } from 'src/app/shared/helper';

export class WhiteLabelChartStatistics extends Model {
  @Expose() gender: UserGender;
  @Expose() count: number;
  @Expose() day?: number;
  @Expose() hour?: number;
  @Expose() month?: number;
  @Expose() year?: number;
  @Expose()
  @Transform(({ obj }) => {
    let label;
    if (
      obj &&
      (checkIfNoValue(obj?.day) || checkIfNoValue(obj?.hour) || checkIfNoValue(obj?.month) || checkIfNoValue(obj?.year))
    ) {
      label = obj && (obj?.day || (checkIfNoValue(obj?.hour) ? `${obj?.hour}` : null) || obj?.month || obj?.year);
    }
    return label ? `${label}` : null;
  })
  label: string;
}
